import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=3610267c&"
import script from "./highlight.vue?vue&type=script&lang=js&"
export * from "./highlight.vue?vue&type=script&lang=js&"
import style0 from "./highlight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports